import { render } from "./TermsCondition.vue?vue&type=template&id=fa8c91d0"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leonardoprado/Documents/My Projects/Natalia/nuron-nft-vue-js-template-2024-03-07-14-00-41-utc/nuron-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__